import {Cache} from '../utils/Cache'
import { getFromDB } from "../../firebase";

export const TeamsDB = {
  
  getFromPrimeraFEB: async (fromCache) => {
    const teamsStored = Cache.getWithExpiry(Cache.keyTeams)
    if (teamsStored === null || !fromCache) {
      try {
        const queryData = {table: 'teams', conditions: {field: 'otherCategory', operator: '==', value: false}, order: 'order'};
        const teamsData = await getFromDB(queryData);
        Cache.setWithExpiry(Cache.keyTeams, teamsData);
        return teamsData;
      } catch (error) {
        console.error('Error al obtener los datos de los equipos:', error);
        throw new Error('Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde.');
      }
    } else {
      return teamsStored;
    }
  }
}